import findWithRegex from "find-with-regex";

import { re as unicodeRegex } from "./utils/emojiRegex";

export default (contentBlock, callback) => {
  findWithRegex(unicodeRegex, contentBlock, callback);
};
